@if(user.isInternal) { <span class="font-s" [ngClass]="loading ? 'color-transparent loading-animate' : ''">Niederlassungen:</span> }
@if(user.isCustomer) { <span class="font-s" [ngClass]="loading ? 'color-transparent loading-animate' : ''">Unternehmen:    </span> }

@if (loading) { <span class="loading-animate height-36 c620-width-full width-min-200"></span> }
@else {
  <div class="am-flex-align am-flex-justify gap-xs c620-width-full width-min-200 b-grey b-radius-wide pt-xxs pb-xxs pl-xs pr-xs font-s hover-active-blue" (click)="openPopup()">
    <span class="am-flex-align gap-xs">
      <span class="font-icon am-flex-center icon-pin color-blue"></span>
      <span class="am-flex-align gap-xxs">
        @if(user.isInternal) {
          @if (!activePills.length || activePills.length === pills.length) { <span class="font-500">Alle</span>                                            }
          @else                                                            { <span class="font-500">{{ activePills.length }} von {{ pills.length }}</span> }
          <span>ausgewählt</span>
        }
        @if(user.isCustomer) { <span>{{ activePills[0]?.name }}</span> }
      </span>
    </span>
    <span class="font-s am-flex-center icon-arrow-down"></span>
  </div>
}
